import store from '@/store'

if (store.getters['Auth/isLogged']) {
	store.dispatch('Projects/load')
}
